export default "/images/departments-active-dark.svg?7d726e86ae0be1abe1fb529ab7e5497c";